var Elevation;
(function (Elevation) {
    Elevation["flat"] = "flat";
    Elevation["container"] = "container";
    Elevation["interactive"] = "interactive";
    Elevation["raised"] = "raised";
    Elevation["float"] = "float";
    Elevation["hover"] = "hover";
})(Elevation || (Elevation = {}));
export default Elevation;
